/**
 * Overview action-row option lists. Extracted so Overview.jsx can drive
 * both the legacy native selects (during migration) and the new
 * Popover-based ghost-button menus per design handoff.
 */

export const refreshOptions = [
  { label: '1s',  value: 1000 },
  { label: '3s',  value: 3000 },
  { label: '10s', value: 10000 },
  { label: '30s', value: 30000 },
  { label: 'Off', value: 0 },
];

export const sortOptions = [
  { label: 'Added newest',    short: 'Newest',          value: 'newest' },
  { label: 'Added oldest',    short: 'Oldest',          value: 'oldest' },
  { label: 'Captured newest', short: 'Captured newest', value: 'capture_newest' },
  { label: 'Captured oldest', short: 'Captured oldest', value: 'capture_oldest' },
  { label: 'A→Z Filename',    short: 'A→Z',             value: 'filename_asc' },
  { label: 'Z→A Filename',    short: 'Z→A',             value: 'filename_desc' },
];

export function refreshLabel(value) {
  if (value === 0) return 'Off';
  const opt = refreshOptions.find((o) => o.value === value);
  return opt ? opt.label : `${Math.round(value / 1000)}s`;
}

export function sortLabel(value) {
  const opt = sortOptions.find((o) => o.value === value);
  return opt?.short ?? opt?.label ?? value;
}
